Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    COLORS = _STYLES$useStyles.COLORS;
  var badge = {
    paddingHorizontal: (0, _styles.getREM)(0.5),
    paddingVertical: (0, _styles.getREM)(0.25),
    borderRadius: (0, _styles.getREM)(0.625),
    borderWidth: (0, _styles.getREM)(0.0625),
    borderColor: COLORS.steam,
    borderStyle: 'solid',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: (0, _styles.getREM)(1.75)
  };
  var badgeText = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var positiveBadge = {
    backgroundColor: colors.positiveBackground,
    borderColor: colors.navBorder
  };
  var negativeBadge = {
    backgroundColor: colors.negativeBackground,
    borderColor: colors.navBorder
  };
  var badgeTextPositive = {
    color: colors.positive
  };
  var badgeTextNegative = {
    color: colors.negative
  };
  var badgeIconWrapperPositive = {
    color: colors.positive
  };
  var badgeIconWrapperNegative = {
    color: colors.negative
  };
  var badgeIcon = {
    marginLeft: (0, _styles.getREM)(0.5)
  };
  var badgeIconReversed = {
    transform: [{
      rotate: '180deg'
    }]
  };
  var styles = _reactNative.StyleSheet.create({
    badge: badge,
    badgeText: badgeText,
    positiveBadge: positiveBadge,
    badgeTextPositive: badgeTextPositive,
    badgeIconWrapperPositive: badgeIconWrapperPositive,
    badgeIconWrapperNegative: badgeIconWrapperNegative,
    badgeIcon: badgeIcon,
    badgeTextNegative: badgeTextNegative,
    negativeBadge: negativeBadge,
    badgeIconReversed: badgeIconReversed
  });
  return {
    styles: styles
  };
};